import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import { useMutation } from "react-query";
import axios from "axios";
import Popup from "../../popupmodal/Popup";

export default function Category() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      status: "Active",
    },
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API INTEGRATION START
  const { mutate, isSuccess, reset, isLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/categories`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        reset();
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add category",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // POST API END

  // UPDATE API START
  const { mutate: updateApi, isLoading: updateLoading } = useMutation(
    async (postdata) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/categories/${state && state?.id}`,
          postdata
        );
        return response.data;
      } catch (error) {
        console.error("Error while updating data:", error);
        throw error;
      }
    },
    {
      onSuccess: (val) => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add category",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
      },
    }
  );
  // UPDATE API END

  useEffect(() => {
    setValue("categoryName", state?.categoryName);
    setValue("status", state?.status || "Active");
    setValue("termsAndConditions", state?.termsAndConditions);
  }, [state, setValue]);

  // Form Submit
  const onSubmit = (data) => {
    let formData = {
      categoryName: data?.categoryName,
      status: data?.status,
      termsAndConditions: data?.termsAndConditions,
    };
    // console.log("Sending:", JSON.stringify(formData.termsAndConditions));
    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Category Add</div>
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Category Name</label>

                    <Controller
                      name="categoryName"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Status</label>
                    <Controller
                      control={control}
                      name="status"
                      defaultValue="Active"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <select
                          onChange={onChange}
                          value={value}
                          className="commonInputCss"
                        >
                          <option value="Active"> Active</option>
                          <option value="Inactive"> Inactive </option>
                        </select>
                      )}
                    />
                  </div>

                  <div className="commonForm_container">
                    <div className="proposalInput_container">
                      <label className="inputLabel">Terms & Condition</label>
                      <Controller
                        control={control}
                        name="termsAndConditions"
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <textarea
                            onChange={onChange}
                            value={value}
                            className="commonInputCss"
                            style={{ height: "400px" }}
                          ></textarea>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn" type="submit">
                  {isLoading || updateLoading ? (
                    <>
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Category Added Successfully!"
        updatemessage="Category Updated Successfully!"
        state={state?.id}
        navigateUrl="/setting/categoryView"
      />
    </>
  );
}
